import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [wallet, setWallet] = useState({ balance: 0, aeps_balance: 0 });

  const refreshBalance = useCallback(async () => {
    try {
      const { data } = await api.get("/balance");
      setWallet(data);
    } catch {}
  }, []);

  useEffect(() => {
    api.get("/auth/me")
      .then(({ data }) => { setUser(data); setWallet({ balance: data.balance, aeps_balance: data.aeps_balance }); })
      .catch(() => setUser(false));
  }, []);

  const login = async (login, password, adminKey) => {
    const { data } = adminKey ? await api.post("/auth/admin-login", { login, password, key: adminKey }) : await api.post("/auth/login", { login, password });
    if (data.mfa_required) return { mfa: data };
    return applyLogin(data);
  };

  const verifyMfa = async (challenge, code) => {
    const { data } = await api.post("/auth/mfa/verify", { challenge, code });
    return applyLogin(data);
  };

  const applyLogin = (data) => {
    localStorage.setItem("np_token", data.token);
    setUser(data.user);
    setWallet({ balance: data.user.balance, aeps_balance: data.user.aeps_balance });
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("np_token");
    setUser(false);
  };

  const reloadUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
  };

  return (
    <AuthCtx.Provider value={{ user, wallet, login, verifyMfa, logout, refreshBalance, reloadUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
